import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="app-footer">
      &copy; {t("footer.copyright")}
      <Link className="footer-link" to="/legal/privacy">{t("footer.privacy")}</Link>
      <span className="footer-sep" aria-hidden="true">·</span>
      <Link className="footer-link" to="/legal/cookies">{t("footer.cookies")}</Link>
      <span className="footer-sep" aria-hidden="true">·</span>
      <Link to="/legal/terms">{t("footer.terms")}</Link>
    </footer>
  );
}
